import type { ReceiptTemplate } from '../schema';

export const kyteTemplate: ReceiptTemplate = {
  id: 'kyte',
  name: 'Kyte Receipt',
  brand: 'KYTE',
  description: 'Kyte car rental receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'kyte-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'KYTE',
        businessNameFontSize: 24,
        addressLines: ['CAR RENTAL DELIVERED'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'kyte-rental',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'booking', label: 'Booking #:', value: 'KYTE-847291' },
          { id: 'renter', label: 'Renter:', value: 'John Doe' },
        ],
        column2: [
          { id: 'start', label: 'Start:', value: '01/02/2026' },
          { id: 'end', label: 'End:', value: '01/05/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'kyte-vehicle',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'VEHICLE:\n2024 Toyota RAV4\nDelivered to: 1200 Dark Ave', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'kyte-charges',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'daily', label: 'RENTAL (3 DAYS)', value: '189.00', isBold: false, isLarge: false },
          { id: 'delivery', label: 'DELIVERY FEE', value: '0.00', isBold: false, isLarge: false },
          { id: 'protection', label: 'PROTECTION', value: '45.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '19.31', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '253.31', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'kyte-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'kyte-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'DELIVERED TO YOUR DOOR\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

